<app-page>
    <app-page-header eyebrow="Gebruikersbeheer" title="Gebruikers">
        <a actions mat-flat-button routerLink="/{{Routenames.users}}/new">
            <i class="fa-regular fa-plus"></i> Gebruiker toevoegen
        </a>
    </app-page-header>

    <div class="filters">
        <app-filter-chips [(value)]="group" [options]="groups()"></app-filter-chips>
        <mat-form-field class="search">
            <i class="fa-regular fa-magnifying-glass ui-faint" matPrefix></i>
            <input (input)="query.set($any($event.target).value)"
                   [value]="query()"
                   aria-label="Zoek op naam of e-mailadres"
                   matInput
                   placeholder="Zoek op naam of e-mailadres"
                   type="search">
        </mat-form-field>
    </div>

    <div class="list-card">
        <app-data-list columns="minmax(0,1.3fr) minmax(0,1.7fr) 120px 120px 16px" minWidth="720px">
            <div app-data-row chevron header>
                <span>Gebruiker</span>
                <span>Rollen</span>
                <span>In dienst</span>
                <span>Uit dienst</span>
            </div>
            @for (row of rows(); track row.user.id) {
                <a [class.out]="row.out" app-data-row chevron routerLink="/{{Routenames.users}}/{{row.user.id}}">
                    <span class="user">
                        <app-avatar [name]="row.user.name" [seed]="row.user.id"></app-avatar>
                        <span class="ui-cell">
                            <span class="ui-strong">{{ row.user.name }}</span>
                            <span class="ui-meta ui-ellipsis">{{ row.user.email }}</span>
                        </span>
                    </span>
                    <span class="roles">
                        @for (role of row.user.roles; track role.key) {
                            <app-status-badge tone="neutral" variant="chip">{{ role.name }}</app-status-badge>
                        } @empty {
                            <app-status-badge [dot]="false" tone="warn">Geen rol</app-status-badge>
                        }
                    </span>
                    @if (row.user.employment_start) {
                        <span class="small-cell">{{ row.user.employment_start | date:'EEE d MMM yyyy' }}</span>
                    } @else {
                        <span class="small-cell ui-faint">Niet ingesteld</span>
                    }
                    @if (row.user.employment_end) {
                        <span class="small-cell">{{ row.user.employment_end | date:'EEE d MMM yyyy' }}</span>
                    } @else {
                        <span class="small-cell none">—</span>
                    }
                </a>
            }
        </app-data-list>
        @if (users() === null) {
            <app-empty-state>Aan het laden...</app-empty-state>
        } @else if (!rows().length) {
            <app-empty-state>Geen gebruikers gevonden.</app-empty-state>
        }
    </div>
</app-page>
